import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyCAu43Qi-vnEXSXF3zeLAtjDby2r3sYPxE',
  authDomain: 'groovefusionbattles.firebaseapp.com',
  projectId: 'groovefusionbattles',
  storageBucket: 'groovefusionbattles.appspot.com',
  messagingSenderId: '439317005545',
  appId: '1:439317005545:web:6405b1e0224373cf185c78'
}

firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()

db.settings({ timestampsInSnapshots: true, merge: true })
export default db
